import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('./../../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/Hinzufuegen_einer_INSTAR_IP_Kamera_zur_Synology_Surveillance_Station_7.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>In diesem Video zeigen wir Ihnen wie Sie schnell und einfach eine INSTAR IP Kamera in Ihrer Synology Surveillance Station hinzufügen können. Schauen Sie auch unsere anderen Videos wo wir zeigen Sie die Synology konfigurieren damit diese das Video der Kamera durchgehend bzw. nur bei Bewegungen aufnimmt. Zudem zeigen wir auch den mobilen Zugriff auf die Synology um so z.B. mit Ihrem Smartphone auf die Synology zuzugreifen von unterwegs um sich die Aufnahmen anzuschauen. Auf <OutboundLink href="https://www.youtube.com/watch?v=034bXd-DYgU" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)